// Task-related enums exported from backend
// These should match exactly with the backend C# enums

// Mirrors the backend OperationalTaskStatusEnum, which is what TaskDto.Status puts on the wire. There is no
// InProgress state server-side; a value here that the backend never sends makes every later value off by one,
// which silently mislabels a resolved task as Pending.
export enum TaskStatusEnum {
  Pending = 1,
  Completed = 2,
  Overdue = 3,
  Cancelled = 4,
}

export enum TaskPriorityEnum {
  Low = 1,
  Medium = 2,
  High = 3,
  Critical = 4,
}

export enum TaskTypeEnum {
  Whitelist = 1,
  Withdrawal = 2,
  Merchant = 3,
  Deposit = 4,
  Risk = 5,
  SystemWhitelist = 6,
  SystemWithdrawal = 7,
  SystemDeposit = 8,
  SystemRisk = 9,
  TransactionAdjustment = 10,
  DepositReversal = 11,
  UnexpectedDeposit = 15,
  PaymentDepositAcknowledge = 19,
  DelegationAllowanceDepleted = 20,
  DelegationReserveDepleted = 21,
  DelegationAllowanceTopUpOverSpend = 22,
  DelegationCapacityDrift = 23,
  ExchangeRateRequired = 24,
  PreLaunchEvmDeposit = 25,
  DelegationAllowanceUnderfunded = 26,
}

export enum TaskTypeFilterEnum {
  Whitelist = 1,
  Withdrawal = 2,
  Deposit = 3,
  Merchant = 4,
  TransactionAdjustment = 5,
  DepositReversal = 6,
  PoolWalletRotation = 7,
  LowRiskAgingMigration = 8,
  UnexpectedDeposit = 9,
  DelegationAllowanceDepleted = 10,
  DelegationReserveDepleted = 11,
  DelegationAllowanceTopUpOverSpend = 12,
  DelegationCapacityDrift = 13,
  ExchangeRateRequired = 14,
  PreLaunchEvmDeposit = 15,
  DelegationAllowanceUnderfunded = 16,
}

export enum TaskResolutionEnum {
  Approved = 1,
  Rejected = 2,
  Cancelled = 3,
}

export enum RiskLevelEnum {
  Unsupported = -1,
  NotAssessed = 0,
  Unknown = 1,
  Low = 2,
  Medium = 3,
  High = 4,
  Severe = 5,
}

export enum RiskAssessmentProviderEnum {
  Chainalysis = 1,
}

export enum NotificationTypeEnum {
  TaskCreated = 'TaskCreated',
  TaskUpdated = 'TaskUpdated',
  TaskResolved = 'TaskResolved',
}
